import {
  getSkyToken,
  setSkyToken,
  getSkyUser,
  setSkyUser,
  removeSkySession,
  setByKey,
  getByKey,
  setToken,
  getToken,
  getRefreshToken,
  setRefreshToken,
  getProfile,
  setUserProfile,
  hasBindingKey,
  initLoginStore,
  setEnvironment,
  removeToken,
  removeSkyUser
} from "./store";

export const store = {
  setToken,
  getToken,
  getSkyUser,
  setSkyUser,
  setSkyToken,
  removeSkySession,
  getSkyToken,
  setRefreshToken,
  getRefreshToken,
  setByKey,
  getByKey,
  setUserProfile,
  getProfile,
  hasBindingKey,
  removeToken,
  removeSkyUser
};

declare const environment: string;
console.log(`Running in ${environment} environment`);

initLoginStore();
export * from "./state";
